"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.insertRows = insertRows;
exports.removeRows = removeRows;
exports.makeEmptyRow = makeEmptyRow;
exports.clearSelection = clearSelection;
exports.getSelection = getSelection;
exports.clipSnippet = clipSnippet;
exports.getSnippetWidth = getSnippetWidth;
exports.getSnippetHeight = getSnippetHeight;
exports.insertSnippet = insertSnippet;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _range = _interopRequireDefault(require("lodash/range"));

function insertRows(rows, index, addRows) {
  var newRows = rows.slice();
  newRows.splice.apply(newRows, [index, 0].concat((0, _toConsumableArray2.default)(addRows)));
  return newRows;
}

function removeRows(rows, index, amount) {
  var newRows = rows.slice();
  newRows.splice(index, amount);
  return newRows;
}

function makeEmptyRow(columns) {
  return columns.reduce(function (prev, curr) {
    return (0, _objectSpread3.default)({}, prev, (0, _defineProperty2.default)({}, curr, ''));
  }, {});
}

function clearSelection(rows, columns, selection) {
  var newRows = rows.slice();
  var startColumns = Math.max(0, selection.left);
  var endColumns = Math.min(columns.length, selection.right);
  var startRows = Math.max(0, selection.top);
  var endRows = Math.min(rows.length, selection.bottom);
  (0, _range.default)(startRows, endRows).forEach(function (rowIdx) {
    var newRow = (0, _objectSpread3.default)({}, rows[rowIdx]);
    (0, _range.default)(startColumns, endColumns).forEach(function (columnIdx) {
      var column = columns[columnIdx];
      newRow[column] = '';
    });
    newRows[rowIdx] = newRow;
  });
  return newRows;
}

function getSelection(rows, columns, selection) {
  var clippedRows = (0, _range.default)(selection.top, selection.bottom).map(function (rowIdx) {
    var row = rows[rowIdx];
    var clippedCells = (0, _range.default)(selection.left, selection.right).map(function (columnIdx) {
      var column = columns[columnIdx];
      return row[column];
    });
    return clippedCells;
  });
  return clippedRows;
}

function clipSnippet(selection, snippet) {
  var width = selection.right - selection.left;
  var height = selection.bottom - selection.top;
  return snippet.map(function (row) {
    return row.slice(0, width);
  }).slice(0, height);
}

function getSnippetWidth(snippet) {
  return snippet.reduce(function (prev, curr) {
    return Math.max(prev, curr.length);
  }, 0);
}

function getSnippetHeight(snippet) {
  return snippet.length;
}

function insertSnippet(rows, columns, selection, snippet) {
  var newRows = rows.slice();
  var snippetHeight = getSnippetHeight(snippet);
  var snippetWidth = getSnippetWidth(snippet);
  var startColumns = Math.max(0, selection.left);
  var endColumns = Math.min(columns.length, selection.left + snippetWidth);
  var startRows = Math.max(0, selection.top);
  var endRows = Math.min(rows.length, selection.top + snippetHeight);
  (0, _range.default)(startRows, endRows).forEach(function (rowIdx) {
    var newRow = (0, _objectSpread3.default)({}, rows[rowIdx]);
    var snippetRowIdx = rowIdx - startRows;
    var snippetRow = snippet[snippetRowIdx];
    (0, _range.default)(startColumns, endColumns).forEach(function (columnIdx) {
      var column = columns[columnIdx];
      var snippetColumnIdx = columnIdx - startColumns;
      newRow[column] = snippetRow[snippetColumnIdx];
    });
    newRows[rowIdx] = newRow;
  });
  return newRows;
}